import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { Router } from '@angular/router';
import { LocationStrategy } from "@angular/common";
import { AuthService } from '../../../services/auth.service';
/**
 * Reset MFA messsage modal
 */
let ResetMfaMessageModalComponent = class ResetMfaMessageModalComponent {
    constructor(sanitizer, router, location, themeService, auth) {
        this.sanitizer = sanitizer;
        this.router = router;
        this.location = location;
        this.themeService = themeService;
        this.auth = auth;
        this.secondColor = '';
        this.accentColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.user = JSON.parse(localStorage.getItem('user'));
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() { }
    close() {
        this.modal.destroy();
    }
};
ResetMfaMessageModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: Router },
    { type: LocationStrategy },
    { type: WebsiteThemeService },
    { type: AuthService }
];
ResetMfaMessageModalComponent = __decorate([
    Component({
        selector: 'ecd-reset-mfa-message-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./reset-mfa-message-modal.component.html")).default
    })
], ResetMfaMessageModalComponent);
export { ResetMfaMessageModalComponent };
